<script>
const operations = {
  OPERATION_CREATE: 'create'
}

const cards = [
  {
    title: 'Records',
    icon: 'bars',
    statistic: 'total_record'
  }, {
    title: 'Accumulative Balance',
    icon: 'dollar',
    statistic: 'total_amount',
    suffix: 'IDR'
  }
]
export default {
  data: () => ({
    cards,
    ...operations,
    operation: null,
    statistic: null
  }),
  methods: {
    sync(filters) {
      this.$http.get(this.routeUri('hyperion.finances.bank.statistic'), { params: filters})
        .then((r) => this.statistic = r.data)
        .catch((e) => this.handleXhrError(e))
    }
  }
}
</script>
<template>
  <div>
    <a-page-header :ghost="false">
      <template #extra>
        <a-button type="primary" icon="plus" @click="() => operation = OPERATION_CREATE">New Bank</a-button>
      </template>
      <a-row type="flex" justify="space-between">
        <a-statistic v-for="(card, i) in cards" :precision="0" :key="`card-${i}`" :title="card.title" :value="statistic === null ? 0 : statistic[card.statistic]">
          <template #prefix><a-icon :type="card.icon" /></template>
          <template v-if="card.hasOwnProperty('suffix')" #suffix>{{ card.suffix }}</template>
        </a-statistic>
      </a-row>
    </a-page-header>

    <h-bank-list @filtered="sync" />

    <a-drawer :width="720" placement="right" :closable="true" :visible="operation !== null" @close="() => operation = null">
      <template v-if="operation === OPERATION_CREATE">
        <h-bank-form :bank="null" @success="() => operation = null" />
      </template>
    </a-drawer>
  </div>
</template>
